module.exports = __webpack_public_path__ + "static/media/deposit.0c54c103.svg";